import { ISearchExtraBaseFilter } from './ISearchExtraFilters';

/** Область поиска = вкладка страницы результатов. */
export type SearchScope = 'docs' | 'dicts' | 'reports';

/** Режим поиска. AI реализован только для документов. */
export type SearchMode = 'exact' | 'ai';

/**
 * Состояние запроса области.
 * `idle` — запрос ещё не запускался, `loading` — данных ещё нет (скелетон),
 * `refining` — данные на экране, идёт уточнение (фильтр / сортировка / страница):
 * список остаётся, сверху тонкий progress; `cancelled` — поиск прерван пользователем
 * и сам не возобновится.
 */
export type SearchStatus = 'idle' | 'loading' | 'refining' | 'success' | 'error' | 'cancelled';

export interface IOrderByItem {
    asc: boolean;
    propName: string;
}

/** Нормализованный запрос: единственный источник параметров для сервиса. */
export interface ISearchRequest {
    scope: SearchScope;
    text: string;
    mode: SearchMode;
    /** Нумерация с нуля. */
    pageIndex: number;
    pageSize: number;
    orderBy?: IOrderByItem;
    /** Дофильтровка применяется только к документам. */
    filter?: ISearchExtraBaseFilter;
    /**
     * Запрашивать общее количество. Считается на бэке отдельным запросом, поэтому
     * запрашивается только когда меняется сам набор (текст/фильтр/сортировка),
     * но не при простом перелистывании.
     */
    requireTotalCount: boolean;
}

/** Нормализованный ответ любой области. */
export interface ISearchResults<TItem> {
    items: TItem[];
    totalCount: number | undefined;
}

export const SEARCH_SCOPES: readonly SearchScope[] = ['docs', 'dicts', 'reports'] as const;

export const SCOPE_LABELS: Record<SearchScope, string> = {
    docs: 'Документы',
    dicts: 'Справочники',
    reports: 'Отчёты',
};

export const isSearchScope = (value: unknown): value is SearchScope =>
    typeof value === 'string' && (SEARCH_SCOPES as readonly string[]).includes(value);
